import { render } from "./AssignAssessmentTaskModal.vue?vue&type=template&id=1154f8f8&scoped=true"
import script from "./AssignAssessmentTaskModal.vue?vue&type=script&lang=js"
export * from "./AssignAssessmentTaskModal.vue?vue&type=script&lang=js"

import "./AssignAssessmentTaskModal.vue?vue&type=style&index=0&id=1154f8f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1154f8f8"]])

export default __exports__